import { useTheme } from '@mui/material';
import { NESTED_CHILDREN_SPACING } from '../tree.consts';
import { TreeIndentOrigin } from '../tree.types';
import { getTrunkLeft } from '../tree.utils';

const useTreeIndent = ({ cellShiftInLevels, leadingSpacing }: TreeIndentOrigin) => {
  const theme = useTheme();
  const toPixels = (spacing: number) => parseFloat(theme.spacing(spacing));
  const levelWidth = toPixels(NESTED_CHILDREN_SPACING);
  const leadingPadding = toPixels(leadingSpacing);

  return {
    trunkLeftOf: (level: number) =>
      getTrunkLeft({ level, cellShiftInLevels, levelWidth, leadingPadding }),
  };
};

export default useTreeIndent;
